var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import classNames from 'classnames';
import { NumberMode } from './number';
import { Numberbox } from '@comall-backend-builder/components-basis';

var NumberPriceMode = function (_super) {
  __extends(NumberPriceMode, _super);

  function NumberPriceMode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 获取展示组件
   */


  NumberPriceMode.prototype.getAvailableDisplayComponent = function (value, displayInfo) {
    var className = displayInfo.className;
    displayInfo = __assign(__assign({}, displayInfo), {
      className: classNames('mode-price', className)
    });
    var str = value.toFixed(2) + '';
    var integerPart = str.slice(0, -3).replace(/\B(?=(?:\d{3})+$)/g, ',');
    var decimalPart = str.slice(-3);
    var priceStr = integerPart + decimalPart;
    return _super.prototype.getAvailableDisplayComponent.call(this, priceStr, displayInfo);
  };
  /**
   * 获取输入组件
   */


  NumberPriceMode.prototype.getControlComponent = function (controlInfo) {
    return React.createElement(Numberbox, __assign({}, controlInfo, {
      min: 0
    }));
  };

  return NumberPriceMode;
}(NumberMode);

export { NumberPriceMode };